import { useState, useEffect } from 'react';
import { Wifi, Users, Shield, Bell, Building, Headphones, Coffee, Briefcase, Clock, MapPin, Phone, Mail } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const iconMap = {
  Building, Users, Wifi, Shield, Bell, Headphones, Coffee, Briefcase, Clock, MapPin, Phone, Mail
};

export default function ServicesGrid() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/care-cards`);
        setServices(response.data);
      } catch (error) {
        console.error('Error fetching care cards:', error);
      }
    };
    fetchServices();
  }, []);

  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-white" data-testid="services-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-10 lg:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#222] mb-3 sm:mb-4 px-4">
            We Care About You
          </h2>
          <p className="text-[#666] text-sm sm:text-base max-w-3xl mx-auto leading-relaxed px-4">
            <span className="font-semibold text-[#222]">We Go Beyond Workspace.</span> This isn't just about desks and WiFi. It's about building connections, accessing expertise, and being part of a thriving ecosystem designed to help you grow.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 lg:gap-8 max-w-5xl mx-auto">
          {services.length > 0 ? (
            services.map((service, index) => {
              const Icon = iconMap[service.icon] || Building;
              return (
                <div
                  key={service.id || index}
                  className="flex items-start space-x-3 sm:space-x-4 p-4 sm:p-6 bg-white rounded-lg border border-gray-200 transition-all duration-300 hover:shadow-[0_8px_30px_rgba(225,36,41,0.15)] hover:-translate-y-1 group"
                  data-testid={`service-${index}`}
                >
                  <div className="flex-shrink-0 w-12 h-12 sm:w-16 sm:h-16 bg-[#F5F5F5] rounded-full flex items-center justify-center transition-all group-hover:bg-[#E12429] group-hover:shadow-[0_4px_20px_rgba(225,36,41,0.3)]">
                    {service.icon_url ? (
                      <img 
                        src={service.icon_url} 
                        alt={service.title} 
                        className="w-6 h-6 sm:w-8 sm:h-8 object-contain transition-all group-hover:brightness-0 group-hover:invert"
                      />
                    ) : (
                      <Icon className="text-[#E12429] group-hover:text-white transition-colors" size={24} />
                    )}
                  </div>
                  <div className="flex-1">
                    <h3 className="text-base sm:text-lg font-semibold text-[#222] mb-1 sm:mb-2">{service.title}</h3>
                    <p className="text-[#666] text-xs sm:text-sm leading-relaxed">{service.description}</p>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="col-span-2 text-center py-12 text-gray-500">
              Loading services...
            </div>
          )}
        </div>
      </div>
    </section>
  );
}